import './App.css';
import Home from './pages/Home/index';
import Login from './pages/Login/index';
import { Routes, Route,useLocation  } from "react-router-dom";
import SideBar from './Components/SideBar/SideBar';
import Header from './Components/Header/Header';
import Data from './pages/Datasources';
import Goals from "./pages/Goals"
import Eid from './Components/EID/Eid';
import {AuthProvider} from "../src/Contexts/Authprovider"
import { ToastContainer } from 'react-toastify';
import { MVOProvider } from './Contexts/MVOprovider';
import { CategoryProvider } from './Contexts/CategoryProvider';
import Templates from './pages/Templates';
import { TemplateProvider } from './Contexts/TemplateProvider';
import { DatasourceProvider } from './Contexts/DatasourceProvider';
import { SDGProvider } from './Contexts/SDGProvider';
import "/node_modules/react-grid-layout/css/styles.css"
import "/node_modules/react-resizable/css/styles.css"

function App() {
  const { pathname } = useLocation();
  return (
    <AuthProvider>
          <DatasourceProvider>
    <CategoryProvider>
    <MVOProvider>
      <TemplateProvider>
        <SDGProvider>
            <ToastContainer position="top-right"
hideProgressBar={false}
newestOnTop={false}
closeOnClick
draggable={false}
pauseOnHover={false}/>
    <div className="App">
    <meta name="apple-mobile-web-app-capable" content="yes"/>
    <meta name="mobile-web-app-capable" content="yes"></meta>
      <img className='Logo' alt='fluvius' src='./Logo.png' href='https://fluvius.netlify.app/' required data-cy="logo"></img>
      {(pathname !== '/login' && pathname !== '/eid-login' && pathname !== "/test") && <><SideBar/><Header/></>}
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="login" element={<Login />} />
        <Route path="Datasources" element={<Data/>} />
        <Route path="Goals" element={<Goals/>} />
        <Route path="eid-login" element={<Eid/>}/>
        <Route path="Templates" element={<Templates/>}/>
      </Routes>
    </div>
    </SDGProvider>
    </TemplateProvider>
    </MVOProvider>
    </CategoryProvider>
    </DatasourceProvider>
    </AuthProvider>
  );
}

export default App;
